<div class="filters">
    <mat-form-field class="loren-form-field" appearance="outline">
        <mat-label>{{ "asset_details.metering" | transloco }}</mat-label>
        <mat-select
                [formControl]="selectedMetricsControl"
                [multiple]="true"
                panelWidth="max-content"
        >
            <mat-option select-all>
                {{ "operations.select_all" | transloco }}
            </mat-option>
            @for (metering of availableMeterings(); track metering) {
                <mat-option [value]="metering.id">{{
                        metering.description
                    }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
    <div class="period">
        <button mat-icon-button [matTooltip]='"operations.reload" | transloco' (click)="this.refresh$.next()">
            <mat-icon color="primary">refresh</mat-icon>
        </button>
        <period-select [formControl]="periodControl"/>
    </div>
</div>

<div class="loren-asset-details-charts-download">
    <div class="loren-asset-details-charts-download-title-container">
        <h2 class="loren-asset-details-charts-download-title">
            @if (!isHandset()) {
                {{ "asset_details.download_reports_title" | transloco }}
            } @else {
                {{ "asset_details.reports_title" | transloco }}
            }
        </h2>
        @if (hasGpsTracking()) {
            <img
                    class="loren-asset-details-charts-gps-pin"
                    src="/assets/svg/pin.svg"
                    alt="GPS tracking"
                    [matTooltip]="'asset.gps_tracking' | transloco"/>
        }
    </div>
    <div class="loren-asset-details-charts-download-actions">
        @if (!isHandset()) {
            @if (checkMeteringsHaveData() && period()) {
                @if (pdfDownloadOption()) {
                    <mat-radio-group
                            required
                            aria-label="Select a file extension"
                            name="fileExtension"
                            [value]="selectedFileExtension()"
                            (change)="updateSelectedFileExtension($event)">
                        <mat-label>{{ "asset_details.file_type" | transloco }}</mat-label>
                        <div style="display: flex; gap: 12px">
                            @for (option of fileExtensionOptions(); track option) {
                                <div class="loren-asset-details-charts-radio-container">
                                    <mat-radio-button [value]="option">{{
                                            option | uppercase
                                        }}
                                    </mat-radio-button>
                                </div>
                            }
                        </div>
                    </mat-radio-group>
                }
                @if (downloadLoading()) {
                    <mat-spinner [diameter]="40"></mat-spinner>
                } @else {
                    <button
                            matButton="filled"
                            style="margin-top: 20px"
                            (click)="handleDownloadButtonClicked()">
                        <mat-icon>download</mat-icon>
                        {{ "asset_details.download" | transloco }}
                    </button>
                }
            }
        }
    </div>
</div>

<h2 class="loren-asset-details-charts-title">
    {{ "asset_details.diagrams_title" | transloco }}
</h2>

@for (metering of meterings(); track metering) {
    @if (getMeteringKind(metering) === categories.NUMERIC ||
    getMeteringKind(metering) === categories.BINARY ||
    getMeteringKind(metering) === categories.PERCENTAGE) {
        <loren-numeric-line-chart-report
                [refresh$]="refresh$"
                [meterings]="getMeteringsForType(metering)"
                [type]="metering"
                [context]="getMeteringKind(metering)"
                [isHandset]="isHandset()"
                [period]="period()"
                (updateData)="chartUpdatedHandler($event)"/>
    } @else if (getMeteringKind(metering) === categories.TRACKING) {
        <loren-tracking-report [meterings]="getMeteringsForType(metering)"
                               [refresh$]="refresh$"
                               [image]="asset().image"
                               [period]="period()"/>
    } @else if (getMeteringKind(metering) === categories.IMAGE) {
        @for (m of getMeteringsForType(metering); track m.id) {
            <asset-image-history-player [metering]="m" [period]="period()" style="max-width: 1024px;margin-bottom: 8px;"/>
        }
    }
}
